module.exports = __webpack_public_path__ + "img/img_value.58970df4.png";